import axios from 'axios'

// 공휴일 상태 모듈 — 헤더 낮밤 배너 분기 판단 + 관리자 페이지 공용
// 비로그인 페이지(/)에서도 호출되므로 인증 토큰 없이 호출 가능한 /api/user/holidays/window 사용
export default {
    namespaced: true,
    state: () => ({
        // 백엔드에서 받은 휴일 목록 (오늘 ± 30일 범위)
        // [{ holidayDate: 'YYYY-MM-DD', holidayName, isHoliday, ... }, ...]
        holidays: [],
        loaded: false,
        loading: false,
        lastFetchedAt: null,
        error: null
    }),
    getters: {
        // YYYY-MM-DD 문자열 Set (조회 성능)
        holidayDateSet(state) {
            return new Set(
                (state.holidays || [])
                    .filter(h => h && h.holidayDate && h.isHoliday !== false)
                    .map(h => h.holidayDate)
            )
        },
        // 특정 Date 객체 또는 'YYYY-MM-DD' 문자열이 공휴일인지
        isHoliday: (state, getters) => (input) => {
            const key = typeof input === 'string'
                ? input
                : (input instanceof Date ? toIsoDate(input) : null)
            if (!key) return false
            return getters.holidayDateSet.has(key)
        },
        // 휴일(주말+공휴일) 여부 — 헤더 배너용 핵심 getter
        // 평일이면서 공휴일도 아닐 때만 영업일
        isBusinessDay: (state, getters) => (input) => {
            const d = input instanceof Date ? input : new Date(input)
            if (isNaN(d.getTime())) return false
            const dow = d.getDay() // 0=일, 6=토
            if (dow === 0 || dow === 6) return false
            return !getters.isHoliday(toIsoDate(d))
        }
    },
    mutations: {
        SET_LOADING(state, v) { state.loading = v },
        SET_HOLIDAYS(state, list) {
            state.holidays = Array.isArray(list) ? list : []
            state.loaded = true
            state.lastFetchedAt = Date.now()
            state.error = null
        },
        SET_ERROR(state, err) {
            state.error = err
            state.loaded = true // 실패해도 더 안 부르도록 (영업일 판단은 요일만으로 fallback)
        }
    },
    actions: {
        // 헤더 mounted 시 1회 호출. 같은 세션에서 중복 호출 방지.
        async ensureLoaded({ state, commit }, { force = false } = {}) {
            if (state.loading) return
            if (!force && state.loaded) return
            commit('SET_LOADING', true)
            try {
                const res = await axios.get('/api/user/holidays/window')
                commit('SET_HOLIDAYS', res.data || [])
            } catch (e) {
                // 네트워크 실패 시: 요일만으로 분기되도록 빈 배열 유지
                console.warn('[holiday] window 조회 실패 — 요일 분기로 fallback', e?.message)
                commit('SET_ERROR', e?.message || 'fetch failed')
                commit('SET_HOLIDAYS', [])
            } finally {
                commit('SET_LOADING', false)
            }
        }
    }
}

function toIsoDate(d) {
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${dd}`
}
